import * as z from 'zod';

export const CheckoutStatusSchema = z.enum(['DRAFT', 'SUBMITTING', 'SUBMITTED'])

export type CheckoutStatus = z.infer<typeof CheckoutStatusSchema>;